import React from "react";
import { Link } from "react-router-dom";

/**
 * Reusable hero banner with optional invisible click hotspots.
 *
 *   <PageHeroBanner
 *     src="/tapin-radio-hero.png"
 *     alt="Tap IN Radio"
 *     testid="hero-radio"
 *     hotspots={[
 *       { to: "/radio#talk-shows", top: "50%", left: "3%", width: "20%", height: "8%", label: "Talk Shows" },
 *     ]}
 *   />
 *
 * Each hotspot is positioned with percentage coords (relative to the banner
 * image) so the same overlay scales correctly on any viewport. Hotspots are
 * fully invisible — no hover ring, no background — matching the home banner.
 *
 * `hotspots[].href` (instead of `to`) opens an external URL in a new tab.
 */
export default function PageHeroBanner({ src, alt, testid, hotspots = [] }) {
  return (
    <section className="px-3 sm:px-6 md:px-0 pt-24 md:pt-28 pb-4 md:pb-6">
      <div
        data-testid={testid || "page-hero-banner"}
        className="relative max-w-6xl md:max-w-none mx-auto md:mx-0 rounded-2xl md:rounded-none overflow-hidden bg-black"
      >
        <img
          src={src}
          alt={alt || ""}
          draggable={false}
          className="block w-full h-auto select-none"
        />
        {hotspots.map((h, i) => {
          const style = {
            top: h.top, left: h.left, width: h.width, height: h.height,
          };
          if (h.href) {
            return (
              <a
                key={i}
                href={h.href}
                target={h.target || "_blank"}
                rel="noreferrer"
                aria-label={h.label}
                data-testid={h.testid}
                className="absolute"
                style={style}
              />
            );
          }
          return (
            <Link
              key={i}
              to={h.to || "/"}
              aria-label={h.label}
              data-testid={h.testid}
              className="absolute"
              style={style}
            />
          );
        })}
      </div>
    </section>
  );
}
